import generateCalendar from 'antd/es/calendar/generateCalendar';
import type { Moment } from 'moment-timezone';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';

const Calendar = generateCalendar<Moment>(momentGenerateConfig);

export default Calendar;
